<!--
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-04-28 14:41:21
-->
<template>
  <div
    v-if="!networkError"
    class="container"
    style="max-width: 540px"
    :dir="isRTL ? 'rtl' : 'ltr'"
    @click="handleCloseSelector"
  >
    <div>
      <template v-if="['id', 'vi', 'en', 'es'].includes(local)">
        <GoogleMap :local="local" />
      </template>
      <template v-else>
        <div v-if="showQuestionnaireBar" class="questionnaire-bar">
          <div class="bar-left">
            <div class="close-box">
              <img src="./assets/close.png" alt="" @click="closeBar" />
            </div>
            {{
              languages.i_verify_result_accurate /*i_verify_result_accurate: 这个结果准确吗？*/
            }}
          </div>
          <div class="bar-right">
            <img
              class="like-icon"
              src="./assets/like.png"
              alt=""
              @click="openQuestionnaire('positive')"
            />
            <img
              src="./assets/not_like.png"
              alt=""
              @click="openQuestionnaire('negative')"
            />
          </div>
        </div>
      </template>

      <div class="header">
        <div class="logo-wrapper" @click="handleClickLogo">
          <div v-if="isRTL" class="name">Timemark</div>
          <img src="./assets/logo.png" class="logo" />
          <span v-if="!isRTL" class="name">Timemark</span>
        </div>
        <div
          class="selector-wrapper"
          @click="(e) => e.stopPropagation()"
          :class="{ open: openDropdown }"
        >
          <div class="selector" @click="handleClickSelector">
            {{ local.toUpperCase() }}
            <img src="../assets/images/down.png" class="down" />
          </div>

          <div class="dropdown" @click="handleSelectLang">
            <div class="item" value="ZH">简体中文</div>
            <div class="item" value="EN">English</div>
            <div class="item" value="ID">Indonesia</div>
            <div class="item" value="MS">Melayu</div>
            <div class="item" value="VI">Tiếng Việt</div>
            <div class="item" value="TH">ภาษาไทย</div>
            <div class="item" value="PT">Português</div>
            <div class="item" value="ES">Español</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-container">
      <van-loading size="24px" vertical>loading...</van-loading>
    </div>
    <div v-else ref="scrollElementRef" class="body-container">
      <div class="result-card">
        <div
          v-if="
            photoVerifyResult?.type === 'success' ||
            photoVerifyResult?.type === 'error'
          "
          :class="[
            'result',
            photoVerifyResult?.type === 'success'
              ? 'result-success'
              : 'result-failed'
          ]"
        >
          <div class="top">
            <img
              class="left-icon"
              :src="
                require(photoVerifyResult?.type === 'success'
                  ? './assets/success_icon.png'
                  : './assets/failed_icon.png')
              "
              alt=""
            />
            <div class="right">
              <div class="verify-result-des">
                {{
                  languages.i_check_result_title /*i_check_result_title: 查验结果为*/
                }}
              </div>
              <div class="verify-result">
                {{
                  photoVerifyResult?.type === 'success'
                    ? languages.i_authentic
                    : languages.i_fake /*i_fake: 虚假*/
                  /*i_authentic: 真实*/
                }}
              </div>
            </div>
            <div
              class="shareBtn"
              :style="{ transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)' }"
              @click="handleClickShare"
            />
          </div>
          <div class="middle">
            <div class="verification-items">
              <div
                v-for="(photoVerifyItem, index) in photoVerifyItems"
                :key="index"
                class="verification-item"
              >
                <div class="item-title">
                  <img
                    class="check-icon"
                    :src="photoVerifyItem.imgSrc"
                    alt=""
                  />
                  <span>{{ photoVerifyItem.title }}</span>
                </div>
                <div
                  v-if="photoVerifyItem.message"
                  :class="['status-message', photoVerifyItem.messageClass]"
                >
                  {{ photoVerifyItem.message }}
                </div>
              </div>
            </div>

            <div class="photo-preview" @click="handlePreviewPhoto">
              <img v-if="photoUrl" :src="photoUrl" alt="Photo" class="photo" />
            </div>

            <div class="code-box">
              <div class="code-box-left">
                {{ languages.i_photo_code /*i_photo_code: 照片码*/ }}
              </div>
              <div class="code-box-right">
                {{ photoInfo?.photoAntiFakeCode }}
              </div>
            </div>

            <div class="info-section">
              <h3>
                {{
                  languages.i_photo_code_original_information /*i_photo_code_original_information: 照片原始信息*/
                }}
              </h3>
              <van-skeleton
                v-if="
                  resultInfoItems[0].value === '' &&
                  codeStatus !== -2303 &&
                  codeStatus !== -8003
                "
                :row="10"
              />
              <template v-else>
                <div
                  v-for="(item, index) in resultInfoItems"
                  :key="index"
                  class="result-info-item"
                >
                  <div class="key">{{ item.key }}</div>
                  <div class="value">
                    {{
                      codeStatus === -2303 || codeStatus === -8003
                        ? '--'
                        : item.value
                    }}
                    <!--                    <div-->
                    <!--                      v-if="item.key === languages.i_version_code"-->
                    <!--                      :style="{-->
                    <!--                        color: '#666666',-->
                    <!--                        fontWeight: 400,-->
                    <!--                        fontSize: '14px'-->
                    <!--                      }"-->
                    <!--                    >-->
                    <!--                      {{ languages.i_please_update_latest_version }}-->
                    <!--                    </div>-->
                  </div>
                </div>
                <div class="result-info-item">
                  <div class="key">{{ languages.i_map /*i_map: 地图*/ }}</div>
                  <div class="value">
                    <div
                      v-if="
                        photoInfo?.location &&
                        codeStatus !== -2303 &&
                        codeStatus !== -8003
                      "
                      class="map-container"
                    >
                      <img
                        v-if="photoInfo?.location"
                        class="mapImage"
                        :src="'data:image/png;base64,' + photoInfo?.location"
                        alt=""
                      />
                      <img
                        class="location-icon"
                        src="./assets/icon-location.png"
                        alt=""
                      />
                    </div>
                    <div
                      v-if="codeStatus !== -2303 && codeStatus !== -8003"
                      class="open-map"
                      @click="handleRedirectToGoogleMaps"
                    >
                      {{
                        languages.i_open_in_map /*i_open_in_map: 在地图中打开*/
                      }}
                      >
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="bottom">
            {{
              languages.i_timemark_anticheat_lab /*i_timemark_anticheat_lab: Timemark 反作弊实验室*/
            }}
          </div>
        </div>

        <div
          v-if="photoVerifyResult?.type === 'unavailable'"
          class="result result-verified"
        >
          <div class="top">
            <img
              v-if="String(codeStatus) === '-8004'"
              class="left-icon"
              src="./assets/invalid_icon_red.png"
              alt=""
            />
            <img
              v-else
              class="left-icon"
              src="./assets/invalid_icon.png"
              alt=""
            />
            <div class="right">
              <div class="verify-result-des">
                {{
                  languages.i_check_result_title /*i_check_result_title: 查验结果为*/
                }}
              </div>
              <div class="verify-result">
                {{ languages.i_unable_verify /*i_unable_verify: 无法验证*/ }}
              </div>
            </div>
            <div
              class="shareBtn"
              :style="{ transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)' }"
              @click="handleClickShare"
            />
          </div>
          <div class="middle">
            <div class="result-detail-title">
              {{ languages[photoVerifyResult?.message?.title] }}
            </div>

            <template v-if="photoVerifyResult?.message?.customComponent">
              <component :is="photoVerifyResult?.message?.customComponent"
                >{{ languages[photoVerifyResult?.message?.content] }}
              </component>
            </template>
            <template v-else>
              <div class="result-detail-content">
                {{ languages[photoVerifyResult?.message?.content] }}
              </div>
            </template>

            <div
              v-if="photoVerifyResult?.message?.imgUrl"
              :style="{ width: '100%', height: '87px' }"
            >
              <img
                :style="{ width: '100%', objectFit: 'contain' }"
                :src="photoVerifyResult.message.imgUrl"
                alt=""
              />
            </div>
          </div>
          <div class="bottom result-verified-bottom">
            {{
              languages.i_timemark_anticheat_lab /*i_timemark_anticheat_lab: Timemark 反作弊实验室*/
            }}
          </div>
        </div>
      </div>
      <div class="content">
        <div v-if="photoVerifyResult?.type === 'unavailable'" class="task-id">
          Task ID: {{ taskId.slice(0, 20) }}
        </div>
        <div class="faqs">
          {{
            languages.i_how_guarentee_authenticity /*i_how_guarentee_authenticity: Timemark 如何保证真实性？*/
          }}
        </div>
        <div class="content-item">
          <div class="content-title">
            {{
              languages.i_1preventing_digitalmedia_fraud /*i_1preventing_digitalmedia_fraud: 01 - 防止数字媒体欺诈*/
            }}
          </div>
          <div class="content-content">
            <div class="content-info">
              <span class="content-info-key">{{
                languages.i_1preventing_1antifake
                /*i_1preventing_1antifake: 时间防伪:*/
              }}</span>
              <span class="content-info-value">
                {{
                  languages.i_1preventing_1antifake_content /*i_1preventing_1antifake_content: 即使您更改设备时间，Timemark 仍会显示正确的时间。*/
                }}
              </span>
            </div>
            <div class="content-info">
              <span class="content-info-key">{{
                languages.i_1preventing_2antifake_gps
                /*i_1preventing_2antifake_gps: GPS防伪：*/
              }}</span>
              <span class="content-info-value">
                {{
                  languages.i_1preventing_2antifake_gpscontent /*i_1preventing_2antifake_gpscontent: Timemark 可检测虚假 GPS 信号并验证正确位置。*/
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div class="content-title">
            {{
              languages.i_2guarantee_authenticity_photocode /*i_2guarantee_authenticity_photocode: 02 - 通过“照片编码”确保照片的真实性*/
            }}
          </div>
          <div class="content-content">
            <div class="content-info">
              <span class="content-info-value">
                {{
                  languages.i_2guarantee_authenticity_content /*i_2guarantee_authenticity_content: 照片码由 Timemark 生成，每张照片的照片码都是唯一的。它有助于确保照片由 Timemark 相机拍摄，并具有真实的时间和位置信息。*/
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div class="content-title">
            {{
              languages.i_3photo_verification /*i_3photo_verification: 03 - 照片验真*/
            }}
          </div>
          <div class="content-content">
            <div class="content-info">
              <div class="content-info-value">
                {{
                  languages.i_3photo_verification_centent /*i_3photo_verification_centent: 照片验证可检测照片的实时时间和 GPS 位置，识别照片是否被篡改，并判断是否使用了作弊软件拍摄。这样可以确保您收到的照片是真实的。*/
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="link-wrapper">
          <div class="learning">
            {{ languages.i_h5_contact /*i_h5_contact: 联系我们*/ }}
          </div>
          <div class="apps">
            <img
              v-for="(item, index) in apps"
              :key="index"
              :src="item.img"
              class="app-icon"
              @click="handleOpenApp(item)"
            />
          </div>
        </div>

        <div
          ref="downloadRef"
          class="download-btn-1"
          @click="handleDownload('download')"
        >
          <img src="./assets/ios.png" class="sys-icon" />
          <img src="./assets/android.png" class="sys-icon android" />
          {{ languages.i_download_now /*i_download_now: 立即下载*/ }}
        </div>
      </div>
    </div>
    <Questionnaire
      :show="showQuestionnaire"
      :languages="languages"
      @close="closeQuestionnaire"
      @submit="submitQuestionnaire"
    />
  </div>
  <div v-else class="networkErr">
    <div class="content-title">
      {{
        languages.i_page_network_exception /*i_page_network_exception: 网络异常*/
      }}
    </div>
    <div class="content-des">
      {{
        languages.i_check_net_and_try_again /*i_check_net_and_try_again: 请检查网络后重试*/
      }}
    </div>
    <button class="content-btn" @click="handleRetry">
      {{ languages.i_try_again /*i_try_again: 重试*/ }}
    </button>
  </div>
  <PreviewPhoto
    :show="previewVisible"
    :photoUrl="photoUrl"
    @update:show="handlePreviewPhotoVisible"
    @track="handleSaTrack"
  />
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import lang from './lang.json'
import getUA from '../../../utils/getUA'
import todayAxios from '../../../utils/global/todayAxiosGlobal'
import parseQueryString from '../../../utils/parseQueryString'
import { CODE_STATUS_MAPPING } from './codeStatusMap'
import whatsapp from './assets/whatsapp.png'
import zalo from './assets/zalo.png'
import messenger from './assets/messenger.png'
import mail from './assets/mail.png'
import sa from '../../../utils/saUtilsGlobal'
import Questionnaire from './components/Questionaire/index.vue'
import { Toast } from 'vant'
import PreviewPhoto from './components/PreviewPhoto'
import { formatVersionCode } from '@utils/utils'
import { mapVersionCode } from '../../../utils/global/versionUtils'
import GoogleMap from './components/GoogleMap.vue'

const appStoreURL =
  'https://apps.apple.com/app/apple-store/id6446071834?pt=126093046&ct=timemark_official_h5_introduce&mt=8'
const apkURL =
  'https://play.google.com/store/apps/details?id=com.oceangalaxy.camera.new&referrer=utm_source%3Dtimemark_official_h5_introduce'
const query = parseQueryString()
const UA = getUA()
const defaultLocal =
  navigator.language === 'zh-TW' ? 'zh-TW' : navigator.language.split('-')[0]
const local = ref(defaultLocal)

// 检测是否为阿拉伯语（RTL语言）
const isRTL = ref(defaultLocal === 'ar')
// const isRTL = ref(false)

const networkError = ref(false)
const showQuestionnaireBar = ref(true)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }

    return ''
  }
})
const codeStatusMap = ref(CODE_STATUS_MAPPING)

/**
 * 动态添加meta标签
 * <meta name="description" content="">
 */
const descMeta = document.createElement('meta')
descMeta.setAttribute('name', 'description')
descMeta.setAttribute(
  'content',
  languages.i_timemark_slogan.replace(
    /\n/g,
    ' '
  ) /*i_timemark_slogan: 最值得您信赖的水印相机*/
)
document.querySelector('head').appendChild(descMeta)

const apps = [
  {
    img: whatsapp,
    url: 'https://chat.whatsapp.com/L1jLkNjBEy1AiYvTe3CSxV',
    name: 'whatsApp'
  },
  {
    img: zalo,
    url: 'https://zalo.me/g/aqadto479',
    name: 'zalo'
  },
  {
    img: messenger,
    url: 'https://m.me/timemarkcamera',
    name: 'fbMessenger'
  },
  {
    img: mail,
    url: 'mailto:timemarkofficial@gmail.com',
    name: 'email'
  }
]

const pageInTime = ref(0)
const scrollElementRef = ref(null)
const downloadRef = ref(null)
const codeStatus = ref(null)
const codeRealStatus = ref(null)
const isSubmit = ref(false)
const getMessages = (message) => {
  if (!message) return ''
  // 将 message 按逗号分割
  const keys = message.split(',')
  // 获取每个 key 对应的文本并拼接
  return keys.map((key) => languages[key.trim()] || key.trim()).join('\n')
}

/**
 * 计算照片日期与当前日期的天数差
 * @param {string} photoDateStr - 照片日期字符串，如 "2025-12-30"
 * @returns {number} 天数差，如果当前日期晚于照片日期返回正数，相等返回0，早于返回负数
 */
const calculateDayDiff = (photoDateStr) => {
  const photoDate = new Date(photoDateStr)
  const currentDate = new Date()
  const timeDiff = currentDate.getTime() - photoDate.getTime()
  return Math.floor(timeDiff / (1000 * 3600 * 24))
}

onMounted(async () => {
  pageInTime.value = new Date().getTime()
  const urlParams = new URLSearchParams(window.location.search)
  // 同时检查 taskid 和 taskId，优先使用有值的那个
  taskId.value = urlParams.get('taskid') || urlParams.get('taskId') || ''
  await getQueryInfo()
  // handleSaTrack('enter')
  window.addEventListener('beforeunload', handleBeforeUnload)
})
// 在组件卸载前移除事件监听器
onBeforeUnmount(() => {
  const pageHeight = scrollElementRef.value.scrollHeight
  const scrollHeight =
    scrollElementRef.value.scrollTop + scrollElementRef.value.offsetHeight
  const ratio = (scrollHeight / pageHeight).toFixed(1)
  handleSaTrack('back', {
    processTime: parseInt((new Date().getTime() - pageInTime.value) / 1000),
    ratio: ratio,
    isShownDownload: scrollHeight + 50 >= downloadRef.value.offsetTop
  })
  window.removeEventListener('beforeunload', handleBeforeUnload)
})

const handleBeforeUnload = (event) => {
  // 执行一些清理操作或保存数据
  const pageHeight = scrollElementRef.value.scrollHeight
  const scrollHeight =
    scrollElementRef.value.scrollTop + scrollElementRef.value.offsetHeight
  const ratio = (scrollHeight / pageHeight).toFixed(1)
  handleSaTrack('back', {
    processTime: parseInt((new Date().getTime() - pageInTime.value) / 1000),
    ratio: ratio,
    isShownDownload: scrollHeight + 50 > downloadRef.value.offsetTop
  })
}

const closeBar = (e) => {
  e.stopPropagation()
  e.preventDefault()
  handleSaTrack('close')
  showQuestionnaireBar.value = false
}
const showQuestionnaire = ref(false)

const openQuestionnaire = (type) => {
  handleSaTrack(type, { url: 'defaultQuestion' })
  handleQuestionnaireSaTrack('enter')
  showQuestionnaire.value = true
}

const closeQuestionnaire = () => {
  !isSubmit.value && handleQuestionnaireSaTrack('close')
  isSubmit.value = false
  showQuestionnaire.value = false
}

const submitQuestionnaire = (feedback) => {
  handleQuestionnaireSaTrack('submit', feedback)
  isSubmit.value = true
}

const handleClickLogo = () => {
  handleSaTrack('appIcon')
  window.removeEventListener('beforeunload', handleBeforeUnload)
  window.location.href = 'https://timemark.com'
}

const openDropdown = ref(false)

const handleClickSelector = () => {
  openDropdown.value = !openDropdown.value
}

const handleSelectLang = (e) => {
  if (e.target.className === 'item') {
    local.value = e.target.getAttribute('value').toLowerCase()
    openDropdown.value = false
    handleSaTrack('changeLanguage', { changeLanguage: local.value })
  }
}

const handleCloseSelector = () => {
  openDropdown.value = false
}

const handleDownload = (actionType) => {
  handleSaTrack(actionType)
  window.location.href = UA.isIOS ? appStoreURL : apkURL
}

const handleOpenApp = (item) => {
  handleSaTrack('connect', { channel: item.name })
  window.location.href = item.url
}

const handleRetry = () => {
  handleSaTrack('retry')
  networkError.value = false
  getQueryInfo()
}

const handleRedirectToGoogleMaps = () => {
  handleSaTrack('map')
  try {
    const lat = photoInfo.value.photoLatLng.split(',')[0]
    const lng = photoInfo.value.photoLatLng.split(',')[1]
    const url = `https://www.google.com/maps?q=${lat},${lng}`
    console.log('url', url)
    window.location.href = url
  } catch (error) {
    console.log('tps://www.google.com/map', error)
  }
}

const taskId = ref('')
const photoUrl = ref('')
const photoInfo = ref({})
const loading = ref(false)
const photoVerifyResult = ref({})
// 照片验证结果信息数组
const photoVerifyItems = ref([
  {
    title: languages.i_verify_time_date /*i_verify_time_date: 时间&日期*/,
    imgSrc: '',
    message: '',
    messageClass: ''
  },
  {
    title: languages.i_verify_location /*i_verify_location: 地点*/,
    imgSrc: '',
    message: '',
    messageClass: ''
  },
  {
    title:
      languages.i_verify_image_analysis /*i_verify_image_analysis: 图像分析*/,
    imgSrc: '',
    message: '',
    messageClass: ''
  }
])
// 照片信息数组
const resultInfoItems = ref([
  { key: languages.i_time, value: '' } /*i_time: 时间*/,
  { key: languages.i_timesheet_date, value: '' } /*i_timesheet_date: 日期*/,
  { key: languages.i_time_zone, value: '' } /*i_time_zone: 时区*/,
  { key: languages.i_verify_location, value: '' } /*i_verify_location: 地点*/,
  { key: languages.i_gps, value: '' } /*i_gps: GPS*/,
  { key: languages.i_app, value: '' } /*i_app: 软件*/,
  { key: languages.i_version_code, value: '' },
  {
    key: languages.i_photo_code_device,
    value: ''
  } /*i_photo_code_device: 设备型号*/
])

// 更新验证项目的基础消息
const updateBaseMessages = () => {
  if (photoVerifyResult.value?.type === 'unavailable') return

  const verifyTypes = ['time', 'location', 'image']
  verifyTypes.forEach((type, index) => {
    const messageData = photoVerifyResult.value?.message?.[type]
    const item = photoVerifyItems.value[index]
    item.message =
      type === 'image'
        ? languages[messageData?.message]
        : getMessages(messageData?.message)
  })
}

// 更新验证项目的服务器数据
const updateServerData = () => {
  if (photoVerifyResult.value?.type === 'unavailable') return

  const { message } = photoVerifyResult.value
  if (message?.time?.hasServer) {
    if (photoInfo.value?.photoTime && photoInfo.value?.photoDate) {
      photoVerifyItems.value[0].message += ` ${photoInfo.value?.photoTime}, ${photoInfo.value?.photoDate}`
    }
  }
  if (message?.location?.hasServer) {
    photoVerifyItems.value[1].message += ` ${
      photoInfo.value?.photoAddress ? photoInfo.value?.photoAddress : ''
    }`
  }
}

// 更新语言相关内容
watch(local, () => {
  // 更新标题
  photoVerifyItems.value[0].title =
    languages.i_verify_time_date /*i_verify_time_date: 时间&日期*/
  photoVerifyItems.value[1].title =
    languages.i_verify_location /*i_verify_location: 地点*/
  photoVerifyItems.value[2].title =
    languages.i_verify_image_analysis /*i_verify_image_analysis: 图像分析*/

  if (photoVerifyItems.value[3]) {
    photoVerifyItems.value[3].title = languages.i_old_version_detacted
    photoVerifyItems.value[3].message =
      languages.i_advise_update_improve_credibility
  }

  // 更新信息项的key
  const keys = [
    'i_time',
    'i_timesheet_date',
    'i_time_zone',
    'i_verify_location',
    'i_gps',
    'i_app',
    'i_version_code',
    'i_photo_code_device'
  ]
  resultInfoItems.value.forEach((item, index) => {
    item.key = languages[keys[index]]
  })

  updateBaseMessages()
  updateServerData()
})

const getQueryInfo = async () => {
  try {
    loading.value = true
    pollData() // 开始轮询
  } catch (e) {
    loading.value = false
    networkError.value = true
  }
}

// 处理照片验证结果数据
const handlePhotoVerifyResult = (responseData) => {
  // responseData.list[0].status = '0'
  photoUrl.value = responseData.list[0].photoUrl
  codeStatus.value = responseData.list[0].status
  photoVerifyResult.value =
    codeStatusMap.value[responseData.list[0].status] ||
    codeStatusMap.value['other']

  if (photoVerifyResult.value?.type !== 'unavailable') {
    const verifyTypes = ['time', 'location', 'image']
    verifyTypes.forEach((type, index) => {
      const messageData = photoVerifyResult.value?.message?.[type]
      const item = photoVerifyItems.value[index]
      item.imgSrc = require(`./assets/global_fill_${messageData?.iconStatus}.png`)
      item.messageClass =
        messageData?.iconStatus === 'error' ? 'status-message-error' : ''
    })
    updateBaseMessages()
  }
}

// 处理照片详细信息
const handlePhotoDetail = (detailData) => {
  const { data } = detailData
  codeRealStatus.value = data.realStatus
  photoInfo.value = {
    taskID: data.taskID,
    photoAddress: data.photoAddress,
    photoTime: data.photoTime,
    photoLatLng: data.photoLatLng,
    photoDate: data.photoDate,
    photoTimeZone: data.photoTimeZone,
    photoApplication: data.photoApplication,
    photoDevice: data.photoDevice,
    photoAntiFakeCode: data.photoAntiFakeCode,
    location: data.location,
    versionCode: mapVersionCode(Number(data.ext.version_code) || ''),
    ext: data.ext
  }

  if (photoVerifyResult.value?.type !== 'unavailable') {
    // 更新结果信息项的值
    const photoInfoMapping = [
      'photoTime',
      'photoDate',
      'photoTimeZone',
      'photoAddress',
      'photoLatLng',
      'photoApplication',
      'versionCode',
      'photoDevice'
    ]
    photoInfoMapping.forEach((key, index) => {
      if (key === 'versionCode') {
        resultInfoItems.value[index].value =
          formatVersionCode(photoInfo.value?.[key]) || '--'
        return
      }
      resultInfoItems.value[index].value = photoInfo.value?.[key] || '--'
    })

    // 更新服务器数据
    updateServerData()
  }

  if (photoInfo.value.versionCode && photoInfo.value.versionCode < 40005000) {
    photoVerifyItems.value.push({
      title: languages.i_old_version_detacted,
      imgSrc: require('./assets/global_fill_warning.png'),
      message: languages.i_advise_update_improve_credibility
    })
  }
}

// 轮询函数
const pollData = async () => {
  try {
    let response = await todayAxios.post('/next/truthful/query/batch', {
      taskID: taskId.value
    })
    const responseData = response.data
    if (responseData.code === 200) {
      if (responseData.data.taskStatus === 5) {
        loading.value = false
        handlePhotoVerifyResult(responseData.data)

        let detailResponse = await todayAxios.post(
          '/next/truthful/query/batch/detail',
          {
            taskID: taskId.value,
            photoUrl: photoUrl.value
          }
        )
        handlePhotoDetail(detailResponse.data)

        // 计算照片日期与当前日期的天数差
        const dayDiff = calculateDayDiff(detailResponse.data.data.photoDate)

        handleSaTrack('loadFinish', {
          content: photoUrl.value,
          dayDiff: dayDiff
        })
        return
      }
      setTimeout(pollData, 1000) // 如果状态不是5，1秒后继续轮询
    } else {
      loading.value = false
    }
  } catch (e) {
    loading.value = false
    networkError.value = true
  }
}

/**
 * 点击分享 icon
 *  */
const handleClickShare = () => {
  handleSaTrack('share')
  let text = `${languages.i_link_verified_result}: ${window.location.href}`
  navigator.clipboard.writeText(text).then(() => {
    Toast.success(`${'link copied'}`)
  })
}

/**
 * 预览验证的图片
 * */
const previewVisible = ref(false)
const handlePreviewPhoto = () => {
  handleSaTrack('photo')
  previewVisible.value = true
}

const handlePreviewPhotoVisible = (val) => {
  previewVisible.value = val
}

const handleSaTrack = (actionType, params = {}) => {
  try {
    let loadResult = ''
    // if (photoVerifyResult.value?.type === 'success') {
    //   loadResult = 'successful'
    // } else if (photoVerifyResult.value?.type === 'error') {
    //   loadResult = 'fake'
    // } else {
    //   loadResult = 'unableToVarify'
    // }

    // 这里上报埋点 使用 codeRealStatus 的值，和界面展示的状态 区分开
    let resType = codeStatusMap.value[codeRealStatus.value].type
    if (resType === 'success') {
      loadResult = 'successful'
    } else if (resType === 'error') {
      loadResult = 'fake'
    } else {
      loadResult = 'unableToVarify'
    }
    if (networkError.value) {
      loadResult = 'networkException'
    }
    const countryCode = navigator.language.split('-')[1]
    const allParams = {
      actionType,
      language: defaultLocal,
      chooseLanguage: local.value,
      loadResult: loadResult,
      fromPlace: query.fromPlace || 'other',
      resultInfo: codeRealStatus.value,
      type: 'photo',
      countryCode: countryCode,
      versionCode: photoInfo.value.versionCode || 0,
      antiCode: photoInfo.value.photoAntiFakeCode,
      ...params
    }
    sa.track('H5_get_action_page_share_photo_code_result', allParams)
  } catch (error) {
    console.log('error', error)
  }
}

// 问卷埋点
const handleQuestionnaireSaTrack = (type, feedback) => {
  try {
    const baseParams = {
      actionType: type,
      resultInfo: codeStatus.value
    }

    const submitParams =
      type === 'submit'
        ? {
            itemContent:
              languages.i_q1_result_accurate /*i_q1_result_accurate: 你认为验证结果准确吗*/,
            content: languages[feedback.split(',')[0]],
            itemID: feedback.split(',')[1]
          }
        : {}
    sa.track('H5_get_action_pop_photo_varify_question', {
      ...baseParams,
      ...submitParams
    })
  } catch (error) {
    console.log('Failed to track questionnaire:', error)
  }
}
</script>

<style>
body,
h1,
h2,
h3,
h4,
p {
  padding: 0;
  margin: 0;
}

* {
  box-sizing: border-box;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
  touch-action: manipulation;
  overflow-x: hidden;
  overscroll-behavior: none;
}

@font-face {
  font-family: BigShoulders;
  src: url('./assets/font/BigShouldersDisplay-Medium.ttf');
  font-display: fallback;
}

@font-face {
  font-family: RobotoCondensed;
  src: url('./assets/font/RobotoCondensed-VariableFont_wght.ttf');
  font-display: fallback;
}
</style>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #1d5689;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  font-family: 'SF Pro Text', 'SF Pro Icons', 'Helvetica Neue', 'Helvetica',
    'Arial', sans-serif;

  .questionnaire-bar {
    padding: 6px 20px 6px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #8fcaf2;

    .bar-left {
      font-size: 14px;
      font-weight: 590;
      color: #144672;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 17px;

      .close-box {
        height: 16px;
        width: 16px;
        padding-left: 2px;
        margin-right: 12px;
        box-sizing: border-box;
      }

      img {
        height: 11px;
        width: 11px;
      }
    }

    .bar-right {
      min-width: 80px;
      text-align: end;
      font-size: 0;

      img {
        height: 28px;
        width: 28px;
      }

      .like-icon {
        margin-right: 12px;
      }
    }
  }

  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: space-between;

    .logo-wrapper {
      display: flex;
      align-items: center;

      .logo {
        width: 34px;
        height: 34px;
        margin-right: 8px;
      }

      .name {
        font-size: 18px;
        font-weight: 590;
        color: #fff;
      }
    }
  }

  .loading-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .body-container {
    padding-top: 22px;
    flex: 1;
    overflow-y: auto;
  }

  .result-card {
    padding: 0 20px;
    margin-bottom: 10px;

    .result {
      border-radius: 4px;

      .top {
        width: 100%;
        border-radius: 4px 4px 0 0;
        background-color: rgba(120, 120, 120, 1);
        min-height: 76px;
        padding: 15px;
        display: flex;
        box-sizing: border-box;
        justify-content: flex-start;

        .left-icon {
          height: 46px;
          width: 46px;
          // margin-right: 14px;
        }

        .right {
          flex-grow: 1;
          margin: 0 14px;

          .verify-result-des {
            font-size: 14px;
            font-weight: 400;
            color: #e0fee7;
            line-height: 17px;
            margin-bottom: 4px;
          }

          .verify-result {
            font-size: 20px;
            font-weight: 600;
            color: #ffffff;
            line-height: 24px;
          }
        }

        .shareBtn {
          width: 32px;
          height: 32px;
          margin-left: 10px;
          background: url('./assets/share_icon.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .middle {
        background-color: #fff;
        box-sizing: border-box;
        padding: 30px 20px;

        .verification-items {
          margin-bottom: 36px;

          .verification-item {
            margin-bottom: 18px;
            position: relative;

            .item-title {
              display: flex;
              align-items: center;
              margin-bottom: 12px;

              .check-icon {
                width: 19px;
                height: 19px;
                margin-right: 4px;
              }

              span {
                font-family: 'RobotoCondensed';
                font-size: 16px;
                color: #444444;
                font-weight: 400;
              }
            }

            .status-message {
              position: relative;
              margin-left: 20px; /* 图标宽度+右边距 */
              padding: 8px 10px;
              background-color: #f5f5f5;
              border-radius: 6px;
              color: #666;
              font-size: 14px;
              display: inline-block;
              max-width: 257px;
              font-family: 'RobotoCondensed';
              white-space: pre-wrap;

              &:before {
                content: '';
                position: absolute;
                top: -5px;
                left: 10px;
                width: 10px;
                height: 10px;
                background-color: #f5f5f5;
                transform: rotate(45deg);
                z-index: 1;
              }

              &.status-message-error {
                color: #ea4d3d;
              }
            }

            &::before {
              content: '';
              position: absolute;
              left: 9px;
              top: 20px;
              bottom: -20px;
              width: 1px;
              background: repeating-linear-gradient(
                to bottom,
                #ccc,
                #ccc 2px,
                transparent 2px,
                transparent 4px
              );
            }

            &:last-child::before {
              display: none;
            }
          }
        }

        .photo-preview {
          width: 100%;
          text-align: center;
          background-color: #f2f2f2;

          .photo {
            max-width: 50%;
            vertical-align: bottom;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
        }

        .code-box {
          display: flex;
          margin-bottom: 30px;

          .code-box-left {
            font-family: 'RobotoCondensed';
            padding: 8px;
            font-size: 15px;
            line-height: 20px;
            font-weight: 400;
            background: rgba(197, 239, 206, 1);
            color: rgba(14, 126, 39, 1);
          }

          .code-box-right {
            font-family: 'RobotoCondensed';
            text-align: center;
            background: rgba(14, 126, 39, 1);
            padding: 8px;
            font-size: 18px;
            line-height: 20px;
            color: #fff;
            flex: 1;
          }
        }

        .result-detail-title {
          font-family: 'RobotoCondensed';
          margin-left: 2px;
          font-size: 20px;
          font-weight: 500;
          line-height: 23.44px;
        }

        .result-detail-content {
          margin-top: 10px;
          font-family: 'RobotoCondensed';
          font-size: 16px;
          font-weight: 400;
          color: #7c7c7c;
          margin-bottom: 10px;
        }

        .info-section {
          h3 {
            font-size: 20px;
            font-weight: 400;
            margin-bottom: 18px;
            color: #222;
            font-family: 'RobotoCondensed';
          }

          .result-info-item {
            display: flex;
            margin-bottom: 18px;
            padding-bottom: 8px;

            &:last-child {
              margin-bottom: 0;
            }

            .key {
              width: 80px;
              font-size: 15px;
              color: #666;
              word-wrap: break-word; /* 允许单词换行 */
              word-break: break-all; /* 强制换行 */
            }

            .value {
              margin-left: 18px;
              flex: 1;
              font-size: 16px;
              color: #000;
              font-weight: 400;
              font-family: 'RobotoCondensed';
              word-wrap: break-word; /* 允许单词换行 */
              word-break: break-all; /* 强制换行 */
            }

            .map-container {
              margin-top: 5px;
              position: relative;
              border-radius: 8px;
              overflow: hidden;

              .mapImage {
                width: 100%;
                max-width: 146px;
                border-radius: 8px;
              }

              .location-icon {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 30px;
                height: 30px;
              }
            }

            .open-map {
              margin-top: 8px;
              color: #1d5689;
              font-weight: 600;
            }
          }
        }
      }

      .bottom {
        background: #f5f5f5;
        padding: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'BigShoulders';
        color: #b6b6b6;
        font-weight: 500;
        font-size: 14px;
      }

      .result-verified-bottom {
        color: rgba(207, 207, 207, 1);
      }
    }

    .result-success,
    .result-failed {
      .top {
        background: #24b343;
      }
    }

    .result-failed {
      .top {
        background: #ea4d3d;

        .right {
          .verify-result-des {
            color: #fee3e0;
          }
        }
      }

      .middle {
        .code-box {
          .code-box-left {
            background: #ffeded;
            color: #ea4d3d;
          }

          .code-box-right {
            background: #ea4d3d;
          }
        }
      }
    }

    .result-verified {
      .top {
        .right {
          .verify-result-des {
            color: #ffffff;
          }
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;

    .task-id {
      margin-bottom: 17px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      // line-height: 22px;
      color: rgba(255, 255, 255, 0.5);
      font-family: 'SF Pro Text';
    }

    .faqs {
      margin-bottom: 10px;
      text-align: center;
      font-size: 18px;
      font-weight: 590;
      line-height: 22px;
      color: #c8ddf0;
      font-family: 'SF Pro Text';
    }

    .content-item {
      width: 100%;
      margin-bottom: 10px;
      border: 1px solid #3e7bb3;
      font-family: 'SF Pro Text';

      .content-title {
        background: #3e7bb3;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        line-height: 19px;
        // text-align: left;
        padding: 12px 16px;
      }

      .content-content {
        padding: 12px 16px;
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        font-weight: 400;
        line-height: 16.7px;

        .content-info {
          margin-bottom: 12px;

          .info-title {
            margin-bottom: 6px;
          }

          .content-info-key {
            font-weight: 700;
          }

          .content-info-value {
            line-height: 16.7px;
          }
        }

        img {
          width: 303px;
          margin-bottom: 22px;
        }
      }
    }

    .link-wrapper {
      margin-top: 50px;

      .learning {
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        color: #fff;
        text-align: center;
      }

      .apps {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 20px;
        margin-top: 20px;

        .app-icon {
          width: 36px;
          height: 36px;
        }
      }
    }

    .download-btn-1 {
      background-color: #000;
      border-radius: 5px;
      margin-top: 70px;
      margin-bottom: 70px;
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 18px;
      padding-right: 27px;
      font-size: 16px;
      font-weight: 590;
      line-height: 19px;
      color: #fff;

      .sys-icon {
        width: 18px;
        height: 18px;

        &.android {
          margin-left: 4px;
          margin-right: 14px;
        }
      }
    }
  }

  .selector-wrapper {
    position: relative;

    &.open {
      .dropdown {
        max-height: 420px;
        box-shadow: 0px 2px 8px 0px #00000033;
      }

      .down {
        transform: rotate(180deg);
      }
    }

    .selector {
      width: 46px;
      height: 24px;
      display: flex;
      align-items: center;
      padding: 3px 8px 3px 8px;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      color: rgba(205, 205, 205, 1);
      background: rgba(227, 230, 239, 0.2);
      justify-content: space-between;

      .down {
        width: 6px;
        height: 3px;
        margin-left: 5px;
        transition: transform 0.2s ease;
      }
    }

    .dropdown {
      position: absolute;
      max-height: 0;
      z-index: 10;
      overflow: hidden;
      transition: max-height 0.2s ease;
      background: #1d5689;
      padding: 8px;
      right: 0;

      .item {
        width: 108px;
        height: 48px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 400;
        color: rgba(205, 205, 205, 1);
      }
    }
  }
}

.networkErr {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .content-title {
    font-size: 24px;
    font-weight: 600;
    line-height: 28x;
    text-align: center;
    margin-bottom: 10px;
  }

  .content-des {
    width: 250px;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    text-align: center;
    margin-bottom: 48px;
    color: #848484;
  }

  .content-btn {
    width: 180px;
    height: 44px;
    border-radius: 4px;
    background: #0093ff;
    border: none;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
    color: #fff;
  }
}
</style>
